import { render, staticRenderFns } from "./DraftSale.vue?vue&type=template&id=7af6febb&scoped=true&"
import script from "./DraftSale.vue?vue&type=script&lang=js&"
export * from "./DraftSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af6febb",
  null
  
)

export default component.exports